"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prefix = '@iotize:device-client.js';
var debug = require('debug');
function lazyDebug(feature, cb) {
    debug(prefix + ":" + feature)(cb());
}
exports.lazyDebug = lazyDebug;
function default_1(feature) {
    var logger = __assign({}, console);
    logger.debug = debug(prefix + ":" + feature);
    return logger;
}
exports.default = default_1;
